(function(module) {
    'use strict';

    function HomePageCtrl(utils, WS, envService, Display, ListModifier, $scope, Group, User, App, $timeout, $q, Store, Playlist, Integration, $http) {

        // defaults
        this.DISPLAYS_CARD = {
            title: 'Displays',
            subtitle: 0,
            text2title: 'Online',
            text2: 0,
            icon: 'fa-television',
            link: 'root.displays',
        };

        this.APPS_CARD = {
            title: 'My Apps',
            subtitle: 0,
            text2title: 'In use',
            text2: 0,
            icon: 'fa-paper-plane-o',
            link: 'root.apps',
        };

        this.GROUPS_CARD = {
            title: 'Groups',
            subtitle: 0,
            text2title: 'In use',
            text2: 0,
            icon: 'fa-link',
            link: 'root.groups',
        };

        this.PLAYLISTS_CARD = {
            title: 'Playlists',
            subtitle: 0,
            text2title: 'In use',
            text2: 0,
            icon: 'fa-calendar',
            link: 'root.playlists',
        };

        this.INTEGRATIONS_CARD = {
            title: 'Integrations',
            subtitle: 0,
            text2title: 'In use',
            text2: 0,
            icon: 'fa-code-fork',
            link: 'root.integrations',
        };

        this.FILES_CARD = {
            title: 'Files',
            subtitle: 0,
            text2title: 'In use',
            text2: 0,
            icon: 'fa-files-o',
            link: 'root.files',
        };

        this.USERS_CARD = {
            title: 'Users',
            subtitle: 0,
            text2title: 'Verified',
            text2: 0,
            icon: 'fa-users',
            link: 'root.users',
        };

        this.$onInit = () => {
            this.utils = utils;

            // WS SUBSCRIPTIONS
            this.records = [];
            this.current = Store.getCurrentUser();
            this.account = Store.getCurrentAccount();
            this.subAccount = Store.getCurrentSubAccountId();
            this.SLS_URI = envService.read('SLS_URI');
            this.featuresFlag = envService.read('features');
            this.getData(this.subAccount);
        };

        this.setDefault = () => {
            this.displays = null;
            this.groups = null;
            this.apps = null;
            this.playlists = null;
            this.integrations = null;
            this.users = null;
            this.files = null;
        };

        this.getData = () => {
            $q
                .all([
                    Display.find({ filter: { fields: ['id', 'online', 'appId', 'groupId', 'playlistId'] } }).$promise,
                    Group.find({ filter: { fields: ['id', 'appId'] } }).$promise,
                    App.find({ filter: { fields: ['id', 'integrationId', 'data'] } }).$promise,
                    Playlist.find({ filter: { fields: ['apps'] } }).$promise,
                    Integration.find({ filter: { fields: ['id'] } }).$promise,
                    User.find({ filter: { fields: ['id', 'emailVerified'] } }).$promise,
                    this.getListOfFiles(this.account.id),
                ])
                .then(this.onDataLoaded)
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.DISPLAY = () => {
            // displays
            this.DISPLAYS_CARD.subtitle = this.displays.length;
            this.DISPLAYS_CARD.text2 = this.displays.filter((display) => display.online).length;
        };

        this.onDataLoaded = (data) => {
            const [displays, groups, apps, playlists, integrations, users, files] = data;

            this.displays = displays;
            this.groups = groups;
            this.apps = apps;
            this.playlists = playlists;
            this.integrations = integrations;
            this.users = users;
            this.files = files;

            _.each(this.displays, (display) => this.addSubscription(display));

            $timeout(() => {

                // displays
                this.DISPLAY();

                // users
                this.USERS_CARD.subtitle = users.length;
                this.USERS_CARD.text2 = users.filter((user) => user.emailVerified).length;

                // apps
                const appsUsedInDisplays = _.chain(displays).map('appId').uniq().compact().value();
                const appsUsedInGroups = _.chain(groups).map('appId').uniq().compact().value();

                const uniqueAppsInAllPlaylists = [];
                playlists.forEach((item, index) => {
                    let uniqueAppsInSeperatePlaylists = _.chain(item.apps).map('id').uniq().compact().value();
                    uniqueAppsInSeperatePlaylists.forEach((singleItem) => {
                        if (uniqueAppsInAllPlaylists.indexOf(singleItem) === -1) {
                            uniqueAppsInAllPlaylists.push(singleItem);
                        }
                    });

                });

                const appsUsed = appsUsedInGroups.concat(appsUsedInDisplays).concat(uniqueAppsInAllPlaylists);
                const appsUsedUnique = _.uniq(appsUsed);

                const appsUsedTotal = Number(appsUsedUnique.length);

                this.APPS_CARD.subtitle = apps.length;
                this.APPS_CARD.text2 = appsUsedTotal;

                //integrations

                const integrationsUsedInApps = _.chain(apps).map('integrationId').uniq().compact().value();
                // minus 1 for the rocket files
                const integrationsUsedTotal = Number(integrationsUsedInApps.length -1);

                this.INTEGRATIONS_CARD.subtitle = integrations.length;
                this.INTEGRATIONS_CARD.text2 = integrationsUsedTotal > 0 ? integrationsUsedTotal : 0;

                //playlists
                const playlistsUsedByDisplays = _.chain(displays).map('playlistId').uniq().compact().value();
                const playlistsUsedByDisplaysTotal = Number(playlistsUsedByDisplays.length);

                this.PLAYLISTS_CARD.subtitle = playlists.length;
                this.PLAYLISTS_CARD.text2 = playlistsUsedByDisplaysTotal;

                //groups

                const groupsUsedByDisplays = _.chain(displays).map('groupId').uniq().compact().value();
                const groupsUsedByDisplaysTotal = Number(groupsUsedByDisplays.length);

                this.GROUPS_CARD.subtitle = groups.length;
                this.GROUPS_CARD.text2 = groupsUsedByDisplaysTotal;

                //files
                //files used by apps
                const usedFilesIds = [];
                const allFilesIds = _.map(this.files, 'id');
                apps.forEach((app) => {
                    if (app.data && app.data.files) {
                        const uniqueFilesInApps = _.chain(app.data.files).map().uniq().compact().value();
                        usedFilesIds.push(uniqueFilesInApps);
                    }
                });

                if (this.files && this.files.length) {
                    this.FILES_CARD.subtitle = this.files.length;
                }

                const usedFilesCount = _.intersection(allFilesIds, _.flatten(usedFilesIds));
                this.FILES_CARD.text2 = usedFilesCount.length;
            });
        };

        this.getListOfFiles = (accountId) => {
            const params = {};
            const subAccountId = Store.getCurrentSubAccountId();
            if (subAccountId) {
                _.set(params, 'subAccountId', subAccountId);
            }
            const request = {
                method: 'GET',
                url: `${this.SLS_URI}/files/list/${accountId}`,
                params,
            };
            return $http(request)
                .then(({ data }) => {
                    return data;
                })
                .catch((error) => {
                    console.log('error-files', error);
                });
        };

        this.$onDestroy = () => {
            _.each(this.records, (record) => {
                record.unsubscribe('status');
                record.discard();
            });
        };

        this.addSubscription = ({ id }) => {
            const recordName = `display:${id}`;
            WS.record.getRecord(recordName).whenReady((record) => {
                this.records.push(record);
                record.subscribe('online', (status) => {
                    ListModifier.updateAttribute(this.displays, id, 'online', status);
                    this.DISPLAY();
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, true);
            });
        };

    }

    function HomePageConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('root.home', {
                url: '/',
                data: {
                    pageTitle: 'HOME.PAGE_TITLE',
                },
                views: {
                    'content@root': {
                        template: '<home-page-component />',
                    },
                },
                bodyClass: 'page--home',
            });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/home');

    }

    module
        .config(HomePageConfig)
        .component('homePageComponent', {
            templateUrl: '/js/home/home.html',
            controller: HomePageCtrl,
        });

})
(angular.module('rocket.components'));
